import type { Match } from './match';

/**
 * The matched substring, marked. Split by index rather than by a regular
 * expression, because the index is already known and a query containing `.`
 * or `(` would otherwise match something the search never did.
 */
export function Highlight({ text, at, length }: { text: string; at: number; length: number }) {
  if (at < 0) return <>{text}</>;

  return (
    <>
      {text.slice(0, at)}
      <mark className="hit">{text.slice(at, at + length)}</mark>
      {text.slice(at + length)}
    </>
  );
}

/** The same thing where a `Match` is already to hand. */
export function HighlightMatch({ text, match }: { text: string; match: Match }) {
  return <Highlight text={text} at={match.at} length={match.length} />;
}

/** For a tile caption, where there's no match object — just the query. */
export function HighlightQuery({ text, query }: { text: string; query: string }) {
  return <Highlight text={text} at={text.toLowerCase().indexOf(query)} length={query.length} />;
}
